import { cn } from "@/lib/utils";

export const KeyboardShortcut = ({
  className,
  text,
  variant = "muted",
}: {
  className?: string;
  text: string;
  variant?: "muted" | "blue" | "red" | "primary" | "onDestructive";
}) => {
  const variantClasses = {
    muted: "text-slate-400",
    blue: "text-blue-600/60",
    red: "text-red-300",
    primary: "text-primary-400",
    onDestructive: "text-red-200",
  };

  return (
    <span className={cn("ml-1 text-sm", variantClasses[variant], className)}>
      {text}
    </span>
  );
};
